/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { getAuthToken } from '../../utils/auth';
import { createDoubleTheDonationClient } from '../../lib/trpc/double-the-donation-main';
import ReactTooltip from 'react-tooltip';
import SuccessAlert from '../alerts/SuccessAlert';
import ErrorAlert from '../alerts/ErrorAlert';
import { FormSelect } from '../../components/ui/form-select';

const tabs = [
  { name: 'Form Options', href: '#formOptions', current: true },
  { name: 'Custom Fields', href: '#tax', current: false },
  { name: 'Tax Receipts', href: '#tax', current: false },
];

export default function CreateFormDrawer(props) {
  const [flagName, setflagName] = useState('');
  const [elementID, setElementID] = useState('');

  const [defaultDonationType, setDefaultDonationType] = useState('Monthly');
  const [oneTimeAmount1, setOneTimeAmount1] = useState('');
  const [oneTimeAmount2, setOneTimeAmount2] = useState('');
  const [oneTimeAmount3, setOneTimeAmount3] = useState('');
  const [oneTimeAmount4, setOneTimeAmount4] = useState('');
  const [monthlyAmount1, setMonthlyAmount1] = useState('');
  const [monthlyAmount2, setMonthlyAmount2] = useState('');
  const [monthlyAmount3, setMonthlyAmount3] = useState('');
  const [monthlyAmount4, setMonthlyAmount4] = useState('');

  const [showOneTimeDefault, setShowOneTimeDefault] = useState(false);
  const [showMonthlyDefault, setShowMonthlyDefault] = useState(false);
  const [showDailyDefault, setShowDailyDefault] = useState(false);
  const [showWeeklyDefault, setShowWeeklyDefault] = useState(false);
  const [showAnnuallyDefault, setshowAnnuallyDefault] = useState(false);
  const [oneTimeDefault, setOneTimeDefault] = useState('');
  const [monthlyDefault, setMonthlyDefault] = useState('');
  const [dailyDefault, setDailyDefault] = useState('');
  const [weeklyDefault, setWeeklyDefault] = useState('');
  const [annuallyDefault, setAnnuallyDefault] = useState('');
  const [separateAmounts, setSeparateAmounts] = useState(true);
  const [requirePhoneNumber, setRequirePhoneNumber] = useState(false);
  const [requireScheduleDonations, setRequireScheduleDonations] = useState(false);
  const [requireBillingAddress, setRequireBillingAddress] = useState(false);
  const [requireCountryDropdown, setRequireCountryDropdown] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('Choose Default Country');
  const [funds, setFunds] = useState([]);
  const [color, setColor] = useState('');

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);

  const [monthlyChecked, setMonthlyChecked] = useState(false);
  const [oneTimeChecked, setOneTimeChecked] = useState(false);
  const [weeklyChecked, setWeeklyChecked] = useState(false);
  const [dailyChecked, setDailyChecked] = useState(false);
  const [annuallyChecked, setAnnuallyChecked] = useState(false);

  const [checkedValues, setCheckedValues] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');

  const [flagPosition, setFlagPosition] = useState('');
  const [flagPageUrl, setFlagPageUrl] = useState('');

  const [emailMessage, emailMessageChange] = useState('');

  const [dtdPublicApiKey, setDtdPublicApiKey] = useState(null);
  const [requireDoubleTheDonation, setRequireDoubleTheDonation] = useState(false);

  const [customInputs, setCustomInputs] = useState([]);

  const [createdForm, setCreatedForm] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // internal functions
  const checkFormErrors = () => {
    if (flagPosition === '') {
      return 'A Flag position is required';
    }
    if (flagPageUrl === '') {
      //crowdfunding is the selected form type and a required field is blank
      return 'A Page URL is required';
    }
    if (flagName === '') {
      return 'Flag Name is required';
    }
    if (color.length != 7) {
      return 'Color is required';
    }
    return '';
  };

  const sendToServer = async () => {
    let returnedError = checkFormErrors();
    console.error('returnedError', returnedError);
    if (returnedError != '') {
      setErrorMessage(returnedError);
      setShowErrorAlert(true);
      // unshowing success alert if it was never closed out
      setShowSuccessAlert(false);
      return;
    }

    setIsDisabled(true);
    const payload = {
      elementName: flagName,
      orientation: flagPosition,
      destinationURL: flagPageUrl,
      nonprofitName: props.merchant.merchantName,
      color: color,
      elementType: 'DONATION_FLAG',
      elementID: elementID,
    };

    const requestOptions = {
      method: createdForm ? 'PATCH' : 'POST', // choose the method based on if it is an updated or a new form
      headers: {
        accept: '*/*',
        'content-type': 'application/json',
        Authorization: await getAuthToken(),
      },
      body: JSON.stringify(payload),
    };

    const url = `${import.meta.env.VITE_APP_ELEMENTS_URL}/elements`;

    let response = await fetch(url, requestOptions);
    let data = await response.json();
    if (data.error) {
      setIsDisabled(false);
      setErrorMessage(data.error);
      setShowErrorAlert(true);
      // unshowing success alert if it was never closed out
      setShowSuccessAlert(false);
      return;
    } else {
      // changeEmailSettings()
      setIsDisabled(false);
      setSuccessMessage(
        createdForm ? 'Element Saved Successfully' : 'Element Created Successfully',
      );
      setCreatedForm(true);
      // unshowing error alert if it was never closed out
      setShowErrorAlert(false);
      setShowSuccessAlert(true);

      if (elementID === '') {
        setElementID(data.elementID);
      }
    }
  };

  // Clear states when modal is closed
  const clearStates = () => {
    // close drawer
    props.setOpen(false);

    // return to default states
    setflagName('');
    setDefaultDonationType('Monthly');
    setSeparateAmounts(true);
    setOneTimeAmount1('');
    setOneTimeAmount2('');
    setOneTimeAmount3('');
    setOneTimeAmount4('');
    setMonthlyAmount1('');
    setMonthlyAmount2('');
    setMonthlyAmount3('');
    setMonthlyAmount4('');
    setShowOneTimeDefault(false);
    setShowMonthlyDefault(false);
    setShowDailyDefault(false);
    setShowWeeklyDefault(false);
    setshowAnnuallyDefault(false);
    setOneTimeDefault('');
    setMonthlyDefault('');
    setDailyDefault('');
    setWeeklyDefault('');
    setAnnuallyDefault('');
    setRequirePhoneNumber(false);
    setRequireScheduleDonations(false);
    setRequireBillingAddress(false);
    setRequireCountryDropdown(false);
    setSelectedCountry('Choose Default Country');
    setFunds([]);
    setColor('');
    setShowSuccessAlert(false);
    setShowErrorAlert(false);
    setIsDisabled(false);
    setMonthlyChecked(false);
    setOneTimeChecked(false);
    setWeeklyChecked(false);
    setAnnuallyChecked(false);
    setDailyChecked(false);
    setCheckedValues([]);
    setRequireDoubleTheDonation(false);
    setCustomInputs([]);
    setCreatedForm(false);
    setElementID('');
    setFlagPosition('');
    setFlagPageUrl('');
  };

  useEffect(() => {
    setTimeout(() => {
      ReactTooltip.rebuild();
    }, 100);
  }, [props.open]);

  useEffect(() => {
    if (checkedValues.length > 1 && selectedValue === '') {
      setSelectedValue('Select an option');
    } else if (checkedValues.length > 1 && checkedValues.includes(selectedValue) === false) {
      setSelectedValue('Select an option');
    } else if (checkedValues.length === 0) {
      setSelectedValue('Select an option');
    } else if (checkedValues.length === 1) {
      setSelectedValue(checkedValues[0]);
    }
  }, [checkedValues]);

  useEffect(() => {
    const myFunction = async () => {
      const organizationId = props.merchant?.organizationId;
      const nonprofit = props.merchant?.merchantName;
      let auth = await getAuthToken();
      if (props.merchant !== null) {
        if (auth === '') {
          const token = await getAuthToken();
          auth = token;
        }

        // grab double the donation api key if it exists
        const response = await createDoubleTheDonationClient({ organizationId, authorization: auth }).getApiKeys({
          nonprofit,
        });
        let responseData = response.body;
        setDtdPublicApiKey(responseData['publicApiKey']);
      }
    };
    myFunction();
  }, [props.merchant]);

  let submitButtonClass =
    'justify-center rounded-md border border-transparent bg-primary py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2';
  if (isDisabled) {
    submitButtonClass =
      'justify-center rounded-md border border-transparent bg-secondary py-2 px-4 text-sm font-medium text-white shadow-sm cursor-not-allowed focus:outline-none';
  }
  return (
    <>
      <Transition.Root show={props.open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-paper-muted0 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0" />
          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                      <div className="flex-1">
                        {/* Header */}
                        <div className="bg-paper-muted px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-ink">
                                New Donation Flag
                              </Dialog.Title>
                              <p className="text-sm text-ink-muted">
                                Get started by filling in the information below to create your new
                                donation flag.
                              </p>
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-ink-muted hover:text-ink-muted"
                                onClick={clearStates}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                              </button>
                            </div>
                          </div>
                        </div>

                        <div>
                          <div className="sm:hidden">
                            <label htmlFor="tabs" className="sr-only">
                              Select a tab
                            </label>
                            {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                            <FormSelect
                              id="tabs"
                              name="tabs"
                              className="block border-edge py-2 pl-3 pr-10 text-base focus:border-accent focus:ring-accent sm:text-sm"
                              defaultValue={tabs.find((tab) => tab.current).name}
                            >
                              {tabs.map((tab) => (
                                <option key={tab.name}>{tab.name}</option>
                              ))}
                            </FormSelect>
                          </div>
                          <div className="hidden sm:block">
                            <div className="border-b border-edge">
                              <nav className="-mb-px flex space-x-8 px-5" aria-label="Tabs"></nav>
                            </div>
                          </div>
                        </div>
                        {/* Divider container */}

                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-edge sm:py-0">
                          {/* Form name */}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            {!createdForm && (
                              <>
                                <div>
                                  <label
                                    htmlFor="form-name"
                                    className="block text-sm font-medium text-ink sm:mt-px sm:pt-2"
                                  >
                                    Flag Name*
                                    <svg
                                      data-tip
                                      data-for="flagNameTooltip"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                      className="ml-1 inline-block h-5 w-5 text-ink-label"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    <ReactTooltip id="flagNameTooltip" effect="solid" place="right">
                                      <p className="text-sm text-white">
                                        This is the name of your donation flag.
                                      </p>
                                      <p className="text-sm text-white">
                                        Each Flag name must have a unique name.
                                      </p>
                                    </ReactTooltip>
                                  </label>
                                </div>
                                <div className="sm:col-span-2">
                                  <input
                                    value={flagName}
                                    onChange={(e) => setflagName(e.target.value.replace('|', ''))}
                                    type="text"
                                    name="flag-name"
                                    id="flag-name"
                                    className="block w-full rounded-md border border-edge-input bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-sage focus:border-sage sm:text-sm"
                                  />
                                </div>
                              </>
                            )}
                            {createdForm && (
                              <>
                                <div>
                                  <label
                                    htmlFor="form-name"
                                    className="block text-sm font-medium text-ink sm:mt-px sm:pt-2"
                                  >
                                    Flag Name*
                                    <svg
                                      data-tip
                                      data-for="flagNameTooltip"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                      className="ml-1 inline-block h-5 w-5 text-ink-label"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    <ReactTooltip id="flagNameTooltip" effect="solid" place="right">
                                      <p className="text-sm text-white">
                                        This is the name of the donation form you created.
                                      </p>
                                    </ReactTooltip>
                                  </label>
                                </div>
                                <div className="sm:col-span-2">
                                  <div className="py-2 text-sm text-ink-secondary">{flagName}</div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Form Type */}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:items-center sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <div>
                              <label
                                htmlFor="form-description"
                                className="block text-sm font-medium text-ink sm:mt-px sm:pt-2"
                              >
                                Flag Position*
                                <svg
                                  data-tip
                                  data-for="flagPositionTooltip"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  className="ml-1 inline-block h-5 w-5 text-ink-label"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <ReactTooltip id="flagPositionTooltip" effect="solid" place="right">
                                  <p className="text-sm text-white">
                                    The Donation Flag is a sticky button that exists as a static
                                    button.{' '}
                                  </p>
                                  <p className="text-sm text-white">
                                    It can be in any of the following positions:
                                  </p>
                                  <p className="text-sm text-white">
                                    Top: Top Left, Bottom: Bottom Left, Right: Middle Right, Left:
                                    Middle Left{' '}
                                  </p>
                                </ReactTooltip>
                              </label>
                            </div>

                            <div className="flex space-x-10 pt-2 text-sm sm:col-span-2">
                              {[
                                { value: 'TOP', label: 'Top' },
                                { value: 'BOTTOM', label: 'Bottom' },
                                { value: 'LEFT', label: 'Left' },
                                { value: 'RIGHT', label: 'Right' },
                              ].map((pos) => (
                                <button
                                  key={pos.value}
                                  type="button"
                                  className="flex items-center gap-1"
                                  onClick={() => setFlagPosition(pos.value)}
                                >
                                  <span
                                    className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 bg-white ${
                                      flagPosition === pos.value ? 'border-sage' : 'border-edge'
                                    }`}
                                    aria-hidden
                                  >
                                    {flagPosition === pos.value && (
                                      <span className="h-2 w-2 rounded-full bg-sage" />
                                    )}
                                  </span>
                                  <span className="text-sm text-ink-secondary">{pos.label}</span>
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Color */}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <div>
                              <label
                                htmlFor="color"
                                className="text-sm font-medium text-ink sm:mt-px sm:pt-2"
                              >
                                Color
                                <svg
                                  data-tip
                                  data-for="colorTooltip"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  className="ml-1 inline-block h-5 w-5 text-ink-label"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <ReactTooltip
                                  id="colorTooltip"
                                  effect="solid"
                                  place="right"
                                  delayHide={500}
                                  className="react-tooltip-clickable-link"
                                >
                                  <p className="text-sm text-white">
                                    Provide a six character Hex color preceded by a &apos;#&apos;.
                                  </p>
                                  <p className="text-sm text-white">
                                    For help getting this value, visit the link below.
                                  </p>
                                  <a
                                    target="_blank"
                                    className="text-sm text-white underline focus:outline-none"
                                    href="https://htmlcolorcodes.com/color-picker/"
                                    rel="noreferrer"
                                  >
                                    https://htmlcolorcodes.com/color-picker/
                                  </a>
                                </ReactTooltip>
                              </label>
                            </div>
                            <div className="sm:col-span-2">
                              <input
                                value={color}
                                placeholder="#000000"
                                onChange={(e) => {
                                  let color = e.target.value;
                                  color = color.toUpperCase();
                                  color = color.replace(/^([^#])/g, '#$1');
                                  color = color.replace(/[^0-9a-fA-F#]/g, '');
                                  if (color.length > 7) {
                                    color = color.substring(0, 7);
                                  }
                                  setColor(color);
                                }}
                                type="text"
                                name="color"
                                id="color"
                                className="flex w-32 rounded-md border border-edge-input bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-sage focus:border-sage sm:text-sm"
                              />
                            </div>
                          </div>

                          {/* Page URL */}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <div>
                              <label
                                htmlFor="color"
                                className="text-sm font-medium text-ink sm:mt-px sm:pt-2"
                              >
                                Page URL*
                                <svg
                                  data-tip
                                  data-for="urlTooltip"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  className="ml-1 inline-block h-5 w-5 text-ink-label"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <ReactTooltip
                                  id="urlTooltip"
                                  effect="solid"
                                  place="right"
                                  delayHide={500}
                                  className="react-tooltip-clickable-link"
                                >
                                  <p className="text-sm text-white">
                                    When a donor clicks on the Donation Flag, they should be
                                  </p>
                                  <p className="text-sm text-white">
                                    redirected to the following link where the donation form is
                                    hosted.
                                  </p>
                                </ReactTooltip>
                              </label>
                            </div>
                            <div className="sm:col-span-2">
                              <input
                                value={flagPageUrl}
                                onChange={(e) => setFlagPageUrl(e.target.value.replace('|', ''))}
                                type="text"
                                name="flag-page-url"
                                id="flag-page-url"
                                className="block w-full rounded-md border border-edge-input bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-sage focus:border-sage sm:text-sm"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-edge px-4 py-5 sm:px-6">
                        <div className="flex h-12 items-center justify-between space-x-3">
                          {showSuccessAlert && (
                            <SuccessAlert
                              message={successMessage}
                              setShowSuccessAlert={setShowSuccessAlert}
                            />
                          )}
                          {showErrorAlert && (
                            <ErrorAlert
                              message={errorMessage}
                              setShowErrorAlert={setShowErrorAlert}
                            />
                          )}
                          {!showSuccessAlert && !showErrorAlert && <div />}

                          <button
                            type="button"
                            className={submitButtonClass}
                            onClick={sendToServer}
                          >
                            {createdForm
                              ? isDisabled
                                ? 'Saving'
                                : 'Save'
                              : isDisabled
                              ? 'Creating'
                              : 'Create'}
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
